import { useState, useEffect } from "react";
import axios from "axios";
import { Box, SimpleGrid, Text, Icon } from "@chakra-ui/react";
import { FaUserTie, FaClipboardList, FaUserCheck, FaTasks } from "react-icons/fa";

// ... existing code ...

function AnalyticCard() {
  const [totalJobs, setTotalJobs] = useState(0);
  const [pendingJobs, setPendingJobs] = useState(0);
  const [assignedJobs, setAssignedJobs] = useState(0);
  const [totalApplicants, setTotalApplicants] = useState(0);

  useEffect(() => {
    const fetchTotalJobs = async () => {
      try {
        const ticketToken = sessionStorage.getItem('ticketToken');
        if (!ticketToken) {
          throw new Error('No ticket token found in sessionStorage');
        }

        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/provider/get-homepage-details`,
           {
          headers: {
            Authorization: `Bearer ${ticketToken}`,
          },
        });

        if (response.data && response.data.totalJobs !== undefined) {
          
          setTotalJobs(response.data.totalJobs);
          setPendingJobs(response.data.pendingJobs);
          setAssignedJobs(response.data.assignedJobs);
          setTotalApplicants(response.data.totalApplicants);
          console.log("Successfully fetched total jobs:", response.data.totalJobs);
        }
      } catch (error) {
        console.error("Error fetching total jobs:", error);
      }
    };

    fetchTotalJobs();
  }, []);

  return (
    <SimpleGrid columns={2} spacing={5} p={5}>
      {/* Total Employees */}
      <Box
        bg="gray.100"
        color="black"
        p={5}
        borderRadius="lg"
        display="flex"
        alignItems="center"
        boxShadow="md"
        _hover={{ borderColor: "blue.500", borderWidth: "1px", boxShadow: "0 0 10px blue.500" }}
      >
        <Icon as={FaUserTie} boxSize={6} mr={3} color="blue.500" />
        <Box>
          <Text fontSize="2xl" fontWeight="bold">{totalApplicants}</Text>
          <Text>Total Applicants</Text>
        </Box>
      </Box>

      {/* Job Openings */}
      <Box
        bg="gray.100"
        color="black"
        p={5}
        borderRadius="lg"
        display="flex"
        alignItems="center"
        boxShadow="md"
        _hover={{ borderColor: "blue.500", borderWidth: "1px", boxShadow: "0 0 10px blue.500" }}
      >
        <Icon as={FaClipboardList} boxSize={6} mr={3} color="blue.500" />
        <Box>
          <Text fontSize="2xl" fontWeight="bold">{totalJobs}</Text>
          <Text>Total Jobs</Text>
        </Box>
      </Box>

      {/* New Applicants */}
      <Box
        bg="gray.100"
        color="black"
        p={5}
        borderRadius="lg"
        display="flex"
        alignItems="center"
        boxShadow="md"
        _hover={{ borderColor: "blue.500", borderWidth: "1px", boxShadow: "0 0 10px blue.500" }}
      >
        <Icon as={FaUserCheck} boxSize={6} mr={3} color="blue.500" />
        <Box>
          <Text fontSize="2xl" fontWeight="bold">{assignedJobs}</Text>
          <Text>Recruited</Text>
        </Box>
      </Box>

      {/* Total Projects */}
      <Box
        bg="gray.100"
        color="black"
        p={5}
        borderRadius="lg"
        display="flex"
        alignItems="center"
        boxShadow="md"
        _hover={{ borderColor: "blue.500", borderWidth: "1px", boxShadow: "0 0 10px blue.500" }}
      >
        <Icon as={FaTasks} boxSize={6} mr={3} color="blue.500" />
        <Box>
          <Text fontSize="2xl" fontWeight="bold">{pendingJobs}</Text>
          <Text>Listed</Text>
        </Box>
      </Box>
    </SimpleGrid>
  );
}

export default AnalyticCard;
